import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AntdIcon from '@ant-design/icons';

import * as St from './SidePanelShapeHeaderTabs.styles';

import { DrawingTabEnum } from '~/core/enums/drawing-tab.enum';
import { useFreeDrawer } from '~/core/hooks/useFreeDrawer';
import AddShapeIcon from '~/icons/add_Shape.svg';
import DrawIcon from '~/icons/draw.svg';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import {
  selectSelectedDrawingTab,
  updateSelectedDrawingTab,
} from '~/redux/slices/shape';
import { useDrawingShapeContext } from '~contexts';

const SidePanelShapeHeaderTabs = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const {
    getters: { drawingShapes },
  } = useDrawingShapeContext();
  const [[oldShapeCounter, currShapeCounter], setShapesCounter] = useState<
    [number, number]
  >([drawingShapes.length, drawingShapes.length]);
  const { activateWithSelectedTab } = useFreeDrawer();
  const selectedTab = useAppSelector(selectSelectedDrawingTab);

  const tabs = [
    {
      Icon: AddShapeIcon,
      title: t('DESIGN_PAGE.DESCRIPTION.PREDEFINED_SHAPE.BOLD'),
      name: DrawingTabEnum.MODIFY_PREDEFINED_SHAPE_TAB,
      handleOnClick: () =>
        activateWithSelectedTab(DrawingTabEnum.MODIFY_PREDEFINED_SHAPE_TAB),
    },
    {
      Icon: DrawIcon,
      title: t('DESIGN_PAGE.DESCRIPTION.FREE_DRAW.BOLD'),
      name: DrawingTabEnum.FREE_DRAWING_TAB,
      handleOnClick: () =>
        activateWithSelectedTab(DrawingTabEnum.FREE_DRAWING_TAB),
    },
  ];

  useEffect(() => {
    setShapesCounter([currShapeCounter, drawingShapes.length]);
  }, [currShapeCounter, drawingShapes.length]);

  useEffect(() => {
    if (
      selectedTab === DrawingTabEnum.FREE_DRAWING_TAB &&
      oldShapeCounter !== currShapeCounter
    ) {
      dispatch(updateSelectedDrawingTab(DrawingTabEnum.SELECTED_SHAPE_TAB));
      setShapesCounter([currShapeCounter, currShapeCounter]);
    }
  }, [currShapeCounter, dispatch, oldShapeCounter, selectedTab]);

  return (
    <St.OptionsContainer>
      {tabs.map(({ Icon, ...tab }) => (
        <St.MenuOption
          key={tab.name}
          onClick={tab.handleOnClick}
          data-is-selected={selectedTab === tab.name}
        >
          <AntdIcon component={() => <Icon />} />
          {tab.title}
        </St.MenuOption>
      ))}
    </St.OptionsContainer>
  );
};

export default SidePanelShapeHeaderTabs;
